import { render, staticRenderFns } from "./AppointmentConfirmation.vue?vue&type=template&id=6467dfbf&scoped=true&"
import script from "./AppointmentConfirmation.vue?vue&type=script&lang=ts&"
export * from "./AppointmentConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentConfirmation.vue?vue&type=style&index=0&id=6467dfbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6467dfbf",
  null
  
)

export default component.exports